export const modulo = (a: number, b: number) => ((a % b) + b) % b;
